import { Box, ColorOptions, ModBox, RadioButtonGroup, Spacer, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { ButtonNew } from '../../../components/AdminButton'
import { useEffect, useState } from 'react'
import { TitleTextWithLabel } from '../../../components/TitleTextWithLabel'
import { useStores } from '../../../data/store'
import { SelectParentEntityList } from '../../EntityManagement/Onboarding/CreateEntity/SelectParentEntityList'

const radiobtnsListArray = (getIndividualConfigValueFromKey: any) => {
  return [
    {
      type: 'isDuplicateTxnAllowed',
      id: '1',
      title: 'Duplicate Transaction allowed ?',
      rbData: ['Yes', 'No'],
      value:
        getIndividualConfigValueFromKey('ALLOW_DUPLICATES') === 'Y'
          ? 'Yes'
          : getIndividualConfigValueFromKey('ALLOW_DUPLICATES') === 'N'
          ? 'No'
          : 'NA',
    },
    {
      type: 'isRandomTxnAllowed',
      id: '2',
      title: 'Random Transaction Allowed ?',
      rbData: ['Yes', 'No'],
      value:
        getIndividualConfigValueFromKey('RANDOM_QR') === 'Y'
          ? 'Yes'
          : getIndividualConfigValueFromKey('RANDOM_QR') === 'N'
          ? 'No'
          : 'NA',
    },
  ]
}

const emEditRefundsConvienienceFeesTips = [
  { type: 'issueRefundAllowed', id: '1', title: 'Issue Refund', rbData: ['Yes', 'No'] },
  { type: 'isConvenienceFeeAllowed', id: '2', title: 'Convenience Fee', rbData: ['Yes', 'No'] },
  { type: 'isTipAllowed', id: '3', title: 'Tip Allowed', rbData: ['Yes', 'No'] },
]

export const ListItem = ({ data, updateSelection, type, isEdit, dataType }: any) => {
  const handleOnchange = (val: string) => {
    updateSelection && updateSelection(data.type, val)
  }

  const handleSelection = (isChecked: any) => {
    updateSelection && updateSelection(data.type, isChecked === 'Yes')
  }
  return (
    <Box pv={8} marginRight={8}>
      <ModBox show={(type === 'MO' || (type === 'EM' && isEdit)) && dataType !== 'TI'}>
        <Text title={data.title} color={'PRIMARY_GREY'} fontSize={12} fontFamily={'jiotype-medium'} lineHeight={18} />
      </ModBox>
      <ModBox show={dataType === 'TWL'} flexWrap={'wrap'} flexDirection={'row'} minWidth={100}>
        <TitleTextWithLabel
          title={data.title}
          label={data.value}
          titleTextColor={'PRIMARY_GREY'}
          labelTextColor={'BLACK_21'}
          titleFontFamily={'jiotype-medium'}
          titleFontSize={12}
          labelFontFamily={'jiotype-medium'}
          labelFontSize={12}
        />
      </ModBox>
      <ModBox show={dataType === 'TI'} flexWrap={'wrap'} flexDirection={'row'} minWidth={100}>
        <TextInputNew
          {...styles.textinput}
          label={data.title}
          value={data.value}
          focusBorderColor={'DISABLED_GREY'}
          editable={true}
          onFocusBorderWidth={1}
          onChange={handleOnchange}
        />
      </ModBox>
      <ModBox show={dataType === 'RBG'} height={54}>
        <RadioButtonGroup
          data={data.rbData}
          textSize={12}
          size={12}
          textPadding={0}
          minItemHeight={36}
          horizontalGap={2}
          direction={'horizontal'}
          value={data?.value}
          onChange={handleSelection}
          callOnChangeOnLoad={false}
        />
      </ModBox>
    </Box>
  )
}

const Upi = ({ type, isEdit }: any) => {
  console.log('UPI type', type, isEdit)
  const {
    getUpiConfig,
    updateUpiConfigs,
    updateGstConsent,
    gstList,
    addGstNumber,
    updatGstNumber,
    deleteGstNumber,
    updateDefaultGst,
    getIndividualConfigValueFromKey,
  } = useStores((store) => ({
    updateUpiConfigs: store.onboarding.updateUpiConfigs,
    getUpiConfig: store.onboarding.getUpiConfig,
    updateGstConsent: store.onboarding.updateGstConsent,
    gstList: store.onboarding.getGstList(),
    addGstNumber: store.onboarding.addGstNumber,
    updatGstNumber: store.onboarding.updatGstNumber,
    deleteGstNumber: store.onboarding.deleteGstNumber,
    updateDefaultGst: store.onboarding.updateDefaultGst,
    gstListLength: store.onboarding.upiConfig.gstConfig.gstNumbers.length,
    getIndividualConfigValueFromKey: store.onboarding.getIndividualConfigValueFromKey,
  }))

  const [gstRows, setGstRows] = useState([])
  const [defaultGst, setDefaultGst] = useState('')
  const [upiConfig, setUpiConfig] = useState({
    isDuplicateTxnAllowed: false,
    isRandomTxnAllowed: false,
    issueRefundAllowed: false,
    isConvenienceFeeAllowed: false,
    isTipAllowed: false,
    qrTxnPattern: getIndividualConfigValueFromKey('INVOICE_REGEX_PATTERN'),
    refundPercentage: '',
    convFeePercentage: '',
    tipPercentage: '',
    transactionLimit: '',
    exitLimit: '',
    transactionCount: '',
    gstConfig: {},
  })

  useEffect(() => {
    isEdit && updateUpiConfigs('qrTxnPattern', getIndividualConfigValueFromKey('INVOICE_REGEX_PATTERN'))
  }, [getIndividualConfigValueFromKey, isEdit, updateUpiConfigs])

  useEffect(() => {
    const data = getUpiConfig()
    setUpiConfig(data)
  }, [getUpiConfig])

  useEffect(() => {
    console.log('gstList: ', JSON.stringify(gstList))
    if (gstList.length > 0) {
      setGstRows(gstList)
    }
  }, [gstList, defaultGst])

  const getEMQrConfigListArray = (getIndividualConfigValueFromKey: any) => {
    return [
      {
        id: '1',
        title: 'Duplicate Transaction allowed ?',
        value: getIndividualConfigValueFromKey('ALLOW_DUPLICATES') === 'Y' ? 'Yes' : 'No',
      },
      {
        id: '2',
        title: 'Random Transaction Allowed?',
        value: getIndividualConfigValueFromKey('RANDOM_QR') === 'Y' ? 'Yes' : 'No',
      },
      {
        id: '3',
        title: 'QR Transaction Pattern',
        value:
          getIndividualConfigValueFromKey('INVOICE_REGEX_PATTERN') !== null
            ? getIndividualConfigValueFromKey('INVOICE_REGEX_PATTERN')
            : 'NA',
      },
    ]
  }

  const getLimitsArray = (upi: any) => {
    return [
      { id: '1', title: 'Transaction Limit (Rs.)', value: upi?.transactionLimit, type: 'transactionLimit' },
      { id: '2', title: 'Exit Limit (Rs.)', value: upi?.exitLimit, type: 'exitLimit' },
      { id: '3', title: 'Transaction Count', value: upi?.transactionCount, type: 'transactionCount' },
    ]
  }

  const getEmEditRefConvFeesTipPercentage = (upi: any) => {
    return [
      { id: '1', title: '% Refund Allowed', type: 'refundPercentage', value: upi?.refundPercentage },
      { id: '2', title: 'Convenience Fee %', type: 'convFeePercentage', value: upi?.convFeePercentage },
      { id: '3', title: 'Tip % of Transaction', type: 'tipPercentage', value: upi?.tipPercentage },
    ]
  }

  const getEmRefundsConvienienceFeesTips = (upi: any) => {
    return [
      { id: '1', title: 'Issue Refund', value: upi?.issueRefundAllowed ? 'Yes' : 'No', type: 'issueRefundAllowed' },
      { id: '2', title: '% Refund Allowed', value: upi?.refundPercentage, type: 'refundPercentage' },
      {
        id: '3',
        title: 'Convenience Fee',
        value: upi?.isConvenienceFeeAllowed ? 'Yes' : 'No',
        type: 'isConvenienceFeeAllowed',
      },
      { id: '4', title: 'Convenience Fee %', value: upi?.convFeePercentage, type: 'convFeePercentage' },
      { id: '5', title: 'Tip Allowed', value: upi?.isTipAllowed ? 'Yes' : 'No', type: 'isTipAllowed' },
      { id: '6', title: 'Tip % of Transaction', value: upi?.tipPercentage, type: 'tipPercentage' },
    ]
  }

  const gstConsentItem = { type: 'gstConsent', id: '1', title: 'GST Consent', rbData: ['Yes', 'No'] }

  const gstFlexMapper = [
    {
      0: 0.8,
      1: 1.2,
      2: 1,
    },
  ]

  const gstHeaderTitles = [
    {
      title: 'Sr. No.',
    },
    {
      title: 'GST Numbers',
    },
    {
      title: 'Mark Default',
    },
  ]

  const onYesPress = () => {
    updateUpiConfigs('applyRefsConvTipsToAllPayments', true)
  }
  const onNoPress = () => {
    updateUpiConfigs('applyRefsConvTipsToAllPayments', false)
  }

  const onNoLimitsPress = () => {
    updateUpiConfigs('applyLimitsAllPayments', false)
  }
  const onYesLimitsPress = () => {
    updateUpiConfigs('applyLimitsAllPayments', true)
  }

  const onQrTxnPatternChange = (value: string) => {
    setUpiConfig({ ...upiConfig, qrTxnPattern: value })
    updateUpiConfigs('qrTxnPattern', value)
  }

  const onAddNewGstNums = () => {
    const id = `${gstList.length + 1}`
    addGstNumber(id, '', false)
  }

  const gstNumberChange = (id: string, gstNum: string) => {
    updatGstNumber(id, gstNum)
  }

  const deleteGst = (data: any) => {
    deleteGstNumber(data?.id)
  }
  const updateDefaultSelection = (id: string, isChecked: string) => {
    setDefaultGst(id)
    updateDefaultGst(id)
  }
  console.log('===> Type isEdit: ', type, isEdit)

  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} minHeight={600}>
      <Text title={'QR Configurations'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox flexWrap={'wrap'} marginTop={32} show={(type === 'EM' && isEdit) || (type === 'MO' && !isEdit)}>
        {radiobtnsListArray(getIndividualConfigValueFromKey).map((item: any, index: number) => {
          return (
            <ListItem
              data={item}
              updateSelection={updateUpiConfigs}
              type={type}
              isEdit={isEdit}
              dataType={'RBG'}
              key={index}
            />
          )
        })}
      </ModBox>
      <ModBox flexWrap={'wrap'} marginTop={32} show={type === 'EM' && !isEdit}>
        {getEMQrConfigListArray(getIndividualConfigValueFromKey).map((item: any, index: number) => {
          return (
            <ListItem
              data={item}
              updateSelection={updateUpiConfigs}
              type={type}
              isEdit={isEdit}
              dataType={'TWL'}
              key={index}
            />
          )
        })}
      </ModBox>
      <ModBox show={isEdit || type === 'MO'} marginTop={16}>
        <TextInputNew
          {...styles.textinputStyle(isEdit)}
          label={'QR Transaction Pattern'}
          focusBorderColor={'DISABLED_GREY'}
          value={upiConfig.qrTxnPattern}
          editable={true}
          onFocusBorderWidth={type === 'EM' ? 1 : 1}
          onChange={onQrTxnPatternChange}
          paddingHorizontal={8}
        />
      </ModBox>
      <ModBox show={false} w={'100%'} marginTop={32}>
        <Text title={'Refunds, Convenience Fees, Tips'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ModBox show={!isEdit} flexDirection={'row'} flexWrap={'wrap'} marginTop={32} width={240}>
          {getEmRefundsConvienienceFeesTips(upiConfig).map((item: any, index: number) => {
            return (
              <ListItem
                data={item}
                updateSelection={updateUpiConfigs}
                type={type}
                isEdit={isEdit}
                dataType={'TWL'}
                key={index}
              />
            )
          })}
        </ModBox>
        <ModBox show={isEdit} flexWrap={'wrap'} flexDirection={'row'} marginTop={32} width={240}>
          <ModBox w={120}>
            {emEditRefundsConvienienceFeesTips.map((item: any, index: number) => {
              return (
                <ListItem
                  data={item}
                  updateSelection={updateUpiConfigs}
                  type={type}
                  isEdit={isEdit}
                  dataType={'RBG'}
                  key={index}
                />
              )
            })}
          </ModBox>
          <ModBox w={120}>
            {getEmEditRefConvFeesTipPercentage(upiConfig).map((item: any, index: number) => {
              return (
                <ListItem
                  data={item}
                  updateSelection={updateUpiConfigs}
                  type={type}
                  isEdit={isEdit}
                  dataType={'TI'}
                  key={index}
                />
              )
            })}
          </ModBox>
        </ModBox>
      </ModBox>
      <ModBox backgroundColor={'#0070B61F' as ColorOptions} borderRadius={2} padding={4} direction={'row'} show={false}>
        <Text
          title={'Do you want to apply values of ‘Refunds, Convenience Fees, Tips’ to all payment instruments?'}
          color={'BLACK_21'}
          fontSize={12}
          fontFamily={'jiotype-medium'}
        />
        <Spacer size={16} direction={'horizontal'} />
        <Box onPress={onYesPress}>
          <Text fontFamily="jiotype-medium" fontSize={14} color={'PRIMARY'} title="Yes" />
        </Box>
        <Spacer size={8} direction={'horizontal'} />
        <Box onPress={onNoPress}>
          <Text fontFamily="jiotype-medium" fontSize={14} color={'PRIMARY'} title={'No'} />
        </Box>
      </ModBox>
      <ModBox show={false} w={'100%'} marginTop={32}>
        <Text title={'Limits'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ModBox show={!isEdit} flexDirection={'row'} flexWrap={'wrap'} marginTop={32} width={'100%'}>
          {getLimitsArray(upiConfig).map((item: any, index: number) => {
            return (
              <ListItem
                data={item}
                updateSelection={updateUpiConfigs}
                type={type}
                isEdit={isEdit}
                dataType={'TWL'}
                key={index}
              />
            )
          })}
        </ModBox>
        <ModBox show={isEdit} flexDirection={'row'} flexWrap={'wrap'} marginTop={32} width={'100%'}>
          {getLimitsArray(upiConfig).map((item: any, index: number) => {
            return (
              <ListItem
                data={item}
                updateSelection={updateUpiConfigs}
                type={type}
                isEdit={isEdit}
                dataType={'TI'}
                key={index}
              />
            )
          })}
        </ModBox>
        <ModBox
          backgroundColor={'#0070B61F' as ColorOptions}
          borderRadius={2}
          padding={4}
          direction={'row'}
          show={type !== 'MO'}>
          <Text
            title={'Do you want to apply values of ‘Limits’ to all payment instruments?'}
            color={'BLACK_21'}
            fontSize={12}
            fontFamily={'jiotype-medium'}
          />
          <Spacer size={16} direction={'horizontal'} />
          <Box onPress={onYesLimitsPress}>
            <Text fontFamily="jiotype-medium" fontSize={14} color={'PRIMARY'} title="Yes" />
          </Box>
          <Spacer size={8} direction={'horizontal'} />
          <Box onPress={onNoLimitsPress}>
            <Text fontFamily="jiotype-medium" fontSize={14} color={'PRIMARY'} title={'No'} />
          </Box>
        </ModBox>
      </ModBox>
      <Box h={1} w={'100%'} backgroundColor={'GRAY_BORDER'} marginTop={32} />
      {/* type === 'EM' || type === 'MO' */}
      <ModBox show={false} w={'100%'} f={1} marginTop={32}>
        <Text title={'GST Configurations'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ModBox show={isEdit}>
          <ListItem
            data={gstConsentItem}
            updateSelection={updateGstConsent}
            type={type}
            isEdit={isEdit}
            dataType={'RBG'}
          />
        </ModBox>
        <ModBox show={!isEdit} marginTop={16}>
          <TextInputNew
            {...styles.textinputStyle(isEdit)}
            label={'GST Consent'}
            focusBorderColor={'DISABLED_GREY'}
            value={upiConfig?.gstConfig?.gstConsent === false ? 'No' : 'Yes'}
            editable={false}
            onFocusBorderWidth={type === 'EM' && isEdit ? 1 : 0}
          />
        </ModBox>
        <SelectParentEntityList
          title={'GST Numbers'}
          hide={type === 'MO'}
          data={gstRows}
          columnFlexMapper={gstFlexMapper}
          headerTitles={gstHeaderTitles}
          onTextInputChange={gstNumberChange}
          onDelete={deleteGst}
          updateDefaultSelection={updateDefaultSelection}
          isEditMode={isEdit}
        />
        <Spacer size={16} direction={'vertical'} />
        <ModBox show={isEdit}>
          <ButtonNew
            type={'secondary'}
            title={'+ Add more GST Numbers'}
            onPress={onAddNewGstNums}
            borderColor={'#0070B6'}
          />
        </ModBox>
        <Spacer size={16} direction={'vertical'} />
      </ModBox>
    </Box>
  )
}
const styles = {
  textinputStyle: (isEditMode: boolean) =>
    ({
      type: 'body12',
      borderColor: isEditMode ? ('#E0E0E0' as ColorOptions) : 'WHITE',
      labelPaddingBottom: 8,
      borderRadius: isEditMode ? 4 : 0,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
      paddingVertical: 8,
      padddingHorizontal: 16,
      color: 'BLACK_21' as ColorOptions,
      onFocusBorderWidth: isEditMode ? 1 : 0,
    } as unknown as TextInputNewProps),
}

export { Upi }
